class Datos {
    buscar(id,cargarDatos) {
        fetch('https://webtvapi.mircloud.us/api/data3.php?id='+id)
        .then((response) => response.json())
        .then((json) => {
            cargarDatos(json);
        });
    }
}
export default Datos;